import { useMutation, useQueryClient } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import type { FormSubmissionPrivacyType } from "src/constants";
import type { EditFormSubmissionPrivacySettingDto } from "src/http";
import { FetchError, queryKeys, useAccessToken } from "src/http";

type Variables = {
  formSubmissionGuid: string;
  privacySetting: FormSubmissionPrivacyType;
};

const useEditFormSubmissionPrivacySetting = () => {
  const { getAccessToken } = useAccessToken();
  const queryClient = useQueryClient();

  async function editFormSubmissionPrivacySettingRequest(variables: Variables) {
    const accessToken = await getAccessToken();
    const body: EditFormSubmissionPrivacySettingDto = {
      privacySetting: variables.privacySetting,
    };

    const response = await fetch(
      `${configuration.apiRootUrl}/form-submissions/${variables.formSubmissionGuid}/privacy-setting`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        method: "put",
        body: JSON.stringify(body),
      },
    );

    if (!response.ok) {
      throw new FetchError(response);
    }
  }

  return useMutation({
    mutationFn: editFormSubmissionPrivacySettingRequest,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries(queryKeys.formSubmissions.getFormSubmissions());
      queryClient.invalidateQueries(queryKeys.formSubmissions.getFormSubmission(variables.formSubmissionGuid));
    },
  });
};

export { useEditFormSubmissionPrivacySetting };
